import React from 'react';
import PropTypes from 'prop-types';
import XIcon from './XIcon';
import { FormattedNumber } from 'react-intl';

const XLargeNumber = (props) => {
    const { value, min, max } = props;
    const valueStr = value.toLocaleString('fullwide', { useGrouping: false, maximumFractionDigits: 0 })
    const trailingZeros = valueStr.match(/0+$/)?.[0].length || 0;
    const leadingNumbers = valueStr.slice(0, valueStr.length - trailingZeros)

    // if (trailingZeros <= 12) {
    //     return <>{value}</>;
    // }
    // const firstThreeDigits = valueStr.slice(0,3);

    return (
        <span>
            <FormattedNumber value={leadingNumbers} minimumFractionDigits={min} maximumFractionDigits={max} />
            {trailingZeros > 3 &&
                <sub className='text-secondary ml-1 mr-1'>
                    <XIcon icon="ellipsis" faStyle={'fas'} className="mr-1"/>
                    {trailingZeros - 3}
                    <XIcon icon="ellipsis" faStyle={'fas'} className="ml-1"/>
                </sub>
            }
            {trailingZeros <= 3 &&
                <>,</>
            }
            000
        </span>
    );
}

XLargeNumber.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.number.isRequired,
        PropTypes.string.isRequired,
    ]),
    min: PropTypes.number,
    max: PropTypes.number,
}

export default XLargeNumber;